import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import HomeTitle from '../components/Home/HomeTitle';
import NewsItem from '../components/Home/NewsItem';
import { ViewIcon, CorrectionsIcon, SelectIcon } from '../components/UI/Icons';
import { URL } from '../constants';
import { formatDate } from '../utils/utility';
import moment from 'moment';
import parse from 'html-react-parser';

//從 APP 移到 Home
let purposeList = Object.entries({ '': '' });
let appStatusList = Object.entries({ '': '' });
let docTypeList = Object.entries({ '': '' });
let appTypeList = Object.entries({ '': '' });
let appResultList = Object.entries({ '': '' });
let stageStatusList = Object.entries({ '': '' });
let orgList = Object.entries({ '': '' });
let speciesTypeList = Object.entries({ '': '' });
let ieTypeList = Object.entries({ '': '' });
let vanIdList = Object.entries({ '': '' });
let compareStateList = Object.entries({ '': '' });
let loginStateList = Object.entries({ '': '' });
let exceptionCodeList = Object.entries({ '': '' });
let tableNameList = Object.entries({ '': '' });
let fiTypeList = Object.entries({ '': '' });

const Home = props => {
    const [noticeList, setNoticeList] = useState([]);
    const [news, setNews] = useState([]);
    const [questions, setQuestions] = useState([]);

    const user = JSON.parse(sessionStorage.getItem('user')).user;

    const load = useCallback(async () => {
        //待辦事項
        await fetch(`${URL}/notice/${user.userDetail.id}`, {
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            method: 'GET',
        }).then(res => res.json()).then(resJson => setNoticeList(resJson));

        //最新公告
        await fetch(`${URL}/system/announcement/home`,{
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            method: 'POST',
            body: JSON.stringify({'groupNo' : user.role.groupNo})
        }).then(res => res.json()).then(resJson => setNews(resJson));

        //FAQ => groupNo
        await fetch(`${URL}/system/commonProblem/home`,{
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            method: 'GET'
        }).then(res => res.json()).then(resJson => setQuestions(resJson));
    }, []);

    const init = useCallback(async () => {
        // init code list
        purposeList = await fetch(`${URL}/system/code/findCode/PURPOSE`, {
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            method: 'GET'
        }).then(res => res.json()).then(purpose => Object.entries(purpose).map(([k, v]) => {
            return v;
        }));

        appStatusList = await fetch(`${URL}/system/code/findCode/APPSTATUS`, {
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            method: 'GET'
        }).then(res => res.json()).then(status => Object.entries(status).map(([k, v]) => {
            return v;
        }));

        docTypeList = await fetch(`${URL}/system/appDoc/findDocType`, {
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            method: 'GET'
        }).then(res => res.json()).then(status => Object.entries(status).map(([k, v]) => {
            return v;
        }));

        appTypeList = await fetch(`${URL}/system/code/findCode/APPTYPE`, {
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            method: 'GET'
        }).then(res => res.json()).then(status => Object.entries(status).map(([k, v]) => {
            return v;
        }));

        appResultList = await fetch(`${URL}/system/code/findCode/APPRESULT`, {
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            method: 'GET'
        }).then(res => res.json()).then(status => Object.entries(status).map(([k, v]) => {
            return v;
        }));

        stageStatusList = await fetch(`${URL}/system/code/findCode/STAGESTATUS`, {
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            method: 'GET'
        }).then(res => res.json()).then(status => Object.entries(status).map(([k, v]) => {
            return v;
        }));

        orgList = await fetch(`${URL}/system/code/findCode/DIRECTION`, {
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            method: 'GET'
        }).then(res => res.json()).then(status => Object.entries(status).map(([k, v]) => {
            return v;
        }));

        speciesTypeList = await fetch(`${URL}/system/code/findCode/SPECIES_TYPE`, {
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            method: 'GET'
        }).then(res => res.json()).then(status => Object.entries(status).map(([k, v]) => {
            return v;
        }));

        ieTypeList = await fetch(`${URL}/system/code/findCode/IE`, {
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            method: 'GET'
        }).then(res => res.json()).then(status => Object.entries(status).map(([k, v]) => {
            return v;
        }));

        vanIdList = await fetch(`${URL}/system/code/findCode/VI`, {
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            method: 'GET'
        }).then(res => res.json()).then(status => Object.entries(status).map(([k, v]) => {
            return v;
        }));

        compareStateList = await fetch(`${URL}/system/code/findCode/CR`, {
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            method: 'GET'
        }).then(res => res.json()).then(status => Object.entries(status).map(([k, v]) => {
            return v;
        }));

        loginStateList = await fetch(`${URL}/system/code/findCode/LOGINSTATUS`, {
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            method: 'GET'
        }).then(res => res.json()).then(status => Object.entries(status).map(([k, v]) => {
            return v;
        }));

        exceptionCodeList = await fetch(`${URL}/system/code/findCode/CE`, {
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            method: 'GET'
        }).then(res => res.json()).then(status => Object.entries(status).map(([k, v]) => {
            return v;
        }));

        tableNameList = await fetch(`${URL}/system/code/findCode/TABLE_LIST`, {
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            method: 'GET'
        }).then(res => res.json()).then(status => Object.entries(status).map(([k, v]) => {
            return v;
        }));

        fiTypeList = await fetch(`${URL}/system/code/findCode/FI_TYPE`, {
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            method: 'GET'
        }).then(res => res.json()).then(status => Object.entries(status).map(([k, v]) => {
            return v;
        }));

    }, []);



    const viewAppCaseHandler = async appCaseNo => {
        const appCase =
            await fetch(`${URL}/apply/viewAppCaseByAppCaseNo/${appCaseNo}`, {
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                method: 'GET'
            }).then(res => res.json());

        props.history.push('/application/applyDocument-ApplyDocumentView', {
            ...props.location.state,
            returnURI: '/application/BidCaseStatusQuery',
            action: 'review',
            appInfo: appCase.appInfo,
            basicInfo: appCase.basicInfo,
            appItems: appCase.appItems,
            attachments: appCase.attachments,
            attachmentInfo: appCase.attachmentInfo,
            selectMammals:appCase.selectMammals,
            applyMethod: (appCase.appInfo.isAgent) ? 'agent' : '',
            email: appCase.email,
            fiForms: appCase.fiForms
        });
    }

    const viewCertDocHandler = async (certNo) => {
        const certDoc = await fetch(`${URL}/approve/findCertDocByCertNo/${certNo}`, {
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            method: 'GET'
        }).then(res => res.json());
        props.history.push('/application/CertificateViewForNotice', { response: certDoc });
    }

    const correctionHandler = async appCaseNo => {
        const appCase =
            await fetch(`${URL}/apply/viewAppCaseByAppCaseNo/${appCaseNo}`, {
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                method: 'GET'
            }).then(res => res.json());

        appCase.appInfo.appDate = moment().format('YYYY-MM-DD');

        props.history.push('/application/applyDocument/ApplyDocumentCreate', {
            ...props.location.state,
            returnURI: '/application/BidCaseStatusQuery',
            action: 'correction',
            appInfo: appCase.appInfo,
            basicInfo: appCase.basicInfo,
            appItems: appCase.appItems,
            attachments: appCase.attachments,
            attachmentInfo: appCase.attachmentInfo,
            isGoBack: true,
            isAgent: appCase.appInfo.isAgent,
            selectMammals:appCase.selectMammals,
            email: appCase.email,
            fiForms: appCase.fiForms
        });
    }

    const approveHandler = async (appCaseNo) => {
        const appCase = await fetch(`${URL}/apply/viewAppCaseByAppCaseNo/${appCaseNo}`, {
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            method: 'GET'
        }).then(res => res.json());

        if (appCase.appInfo.stage === undefined) appCase.appInfo.stage = {};

        if (appCase.fiNotifyRemark === '1') {
            props.history.push('/application/FiCaseReviewOperation', {
                ...props.location.state,
                appInfo: appCase.appInfo,
                basicInfo: appCase.basicInfo,
                appItems: appCase.appItems,
                attachmentInfo: appCase.attachmentInfo,
                attachments: appCase.attachments,
                email: appCase.email,
                originPath: '/',
                fiForms: appCase.fiForms
            });
        } else {
            props.history.push('/application/BidCaseReviewOperation', {
                ...props.location.state,
                appInfo: appCase.appInfo,
                basicInfo: appCase.basicInfo,
                appItems: appCase.appItems,
                attachmentInfo: appCase.attachmentInfo,
                attachments: appCase.attachments,
                email: appCase.email,
                originPath: '/',
                fiForms: appCase.fiForms
            });
        }
    }

    const viewFiCaseHandler = async (id) => {
        const response = await fetch(`${URL}/approve/fiSpecies/getFiCase/${id}`, {
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            method: 'GET'
        }).then(res => res.json());

        if (!response.isSuccess) {
            alert('錯誤，請稍後再試。');
        } else {
            const fiCase = {
                uuid: response.uuid,
                year: response.year,
                seq: response.seq,
                list: response.list,
                expertList: response.expertList
            }
            props.history.push('/Application/fiSpecies/FiSpeciesBatchView', {
                ...props.location.state,
                fiCase: fiCase,
                returnHomeURI: '/'
            })
        }
    }

    const approveSpeciesHandler = async (applyUUID) => {
        props.history.push('/Application/verifySpecies/VerifySpeciesOperation', {id: applyUUID});
    }

    const applySpeciesHandler = () => {
        props.history.push('/Application/applySpecies/ApplySpeciesQuery');
    }

    const correctSpeciesHandler = (applyUUID) => {
        props.history.push('/Application/applySpecies/ApplySpeciesModify', {id: applyUUID});
    }

    useEffect(() => {
        load();
    }, [load]);

    useEffect(() => {
        init();
    }, [init]);

    /*useEffect(() => {
        let changeDate = parseInt(moment(user.changeDate).format("yyyyMMDD"));
        let now = parseInt(moment().format('yyyyMMDD'));

        if (changeDate === now) {
            alert("密碼將到期，請修改密碼");
            props.history.push('/PersonDataMaintain/ChangePassword');
        }
    }, []);*/

    return (
        <div>
            <HomeTitle><img src="../images/index_icon01.png" alt="待辦事項通知" />待辦事項通知</HomeTitle>

            <div>
                <div className="gv_tab_sc"
                     style={{
                         "overflow": "auto",
                         "maxHeight": "410px",
                         "minHeight": "80px",
                         "borderBottom": "7px solid #8dbecd",
                         "backgroundColor": "#fff"
                     }}
                >
                    <table>
                        <thead>
                        {
                            user.role.groupNo !== 'SYUR' ?
                                <tr>
                                    <th>審核</th>
                                    <th>日期</th>
                                    <th>待辦工作項目</th>
                                    <th>待辦內容</th>
                                </tr>
                                :
                                <tr>
                                    <th>檢視</th>
                                    <th>補正</th>
                                    <th>日期</th>
                                    <th>待辦工作項目</th>
                                    <th>待辦內容</th>
                                </tr>
                        }
                        </thead>
                        <tbody>
                        {
                            noticeList.map((notice, index) => (
                                <tr key={index}>
                                    {
                                        (user.role.groupNo !== 'SYUR' && notice.fiCaseUUID !== null) &&
                                        <td align='center'><ViewIcon onClick={() => viewFiCaseHandler(notice.fiCaseUUID)} /></td>
                                    }
                                    {
                                        (user.role.groupNo !== 'SYUR' && notice.applyUUID === null && notice.fiCaseUUID === null) &&
                                        <td align='center'><SelectIcon onClick={() => approveHandler(notice.appCaseNo)} /></td>
                                    }
                                    {
                                        (user.role.groupNo !== 'SYUR' && notice.applyUUID !== null) &&
                                        <td align='center'><SelectIcon onClick={() => approveSpeciesHandler(notice.applyUUID)} /></td>
                                    }
                                    {
                                        (user.role.groupNo === 'SYUR' && notice.applyUUID !== null) &&
                                        <td align='center'><SelectIcon onClick={() => applySpeciesHandler()} /></td>
                                    }
                                    {
                                        (user.role.groupNo === 'SYUR' && notice.appStatus === "3" && notice.applyUUID !== null) &&
                                        <td align='center'><CorrectionsIcon onClick={() => correctSpeciesHandler(notice.applyUUID)} /></td>
                                    }
                                    {
                                        (user.role.groupNo === 'SYUR' && notice.appStatus !== "4" && notice.applyUUID === null) &&
                                        <td align='center'><ViewIcon onClick={() => viewAppCaseHandler(notice.appCaseNo)} /></td>
                                    }
                                    {
                                        (user.role.groupNo === 'SYUR' && notice.appStatus === "4" && notice.certNo && notice.applyUUID === null) &&
                                        <td align='center'><ViewIcon onClick={() => viewCertDocHandler(notice.certNo)} /></td>
                                    }
                                    {
                                        (user.role.groupNo === 'SYUR' && notice.appStatus === "4" && !notice.certNo && notice.applyUUID === null) &&
                                        <td align='center'><ViewIcon onClick={() => viewAppCaseHandler(notice.appCaseNo)} /></td>
                                    }
                                    {
                                        (user.role.groupNo === 'SYUR' && notice.appStatus === "4") &&
                                        <td align='center' />
                                    }
                                    {
                                        (user.role.groupNo === 'SYUR' && notice.appStatus === "3" && notice.applyUUID === null) &&
                                        <td align='center'><CorrectionsIcon onClick={() => correctionHandler(notice.appCaseNo)} /></td>
                                    }
                                    <td align='center'>{formatDate(notice.noticeTime)}</td>
                                    <td align='center'>{notice.subject}</td>
                                    <td>{notice.content}</td>
                                </tr>
                            ))
                        }
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="row index_block2">
                <div className="col-md-6">
                    <div className="news_block">
                        <HomeTitle><img src="../images/index_icon02.png" alt="公布欄" />公布欄</HomeTitle>
                        <ul>
                            {
                                news.map(function(n, i) {
                                    if (n.group !== null) {
                                        delete n.group.functions;
                                    }

                                    return (
                                        <NewsItem key={i} item={moment(n.startTime).format('yyyy-MM-DD')} to={{pathname: '/BulletinBoardCheck', state:{ announcement: {...n, browseTime: n.browseTime + 1}, originPath: '/Home'}}} name={n.subject} />
                                    )
                                })
                            }
                        </ul>
                        <div className="text-right">
                            <Link to={{pathname: '/BulletinBoardQuery'}}>
                                <input type="button" className="btn btn-default btn-sm" value="more" />
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="news_block">
                        <HomeTitle><img src="../images/index_icon03.png" alt="常見問題" />常見問題</HomeTitle>
                        <ul>
                            {
                                questions.map((n, i) => <NewsItem key={i} item={(i + 1) + '.'} to={{pathname: '/CommonProblemCheck', state:{ commonProblem: {...n, browseTime: n.browseTime + 1}, originPath: '/Home'}}} name={parse(n.question)} />)
                            }
                        </ul>
                        <div className="text-right">
                            <Link to="/CommonProblemQuery">
                                <input type="button" className="btn btn-default btn-sm" value="more" />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

        </div >
    );
}

export { purposeList, appStatusList, docTypeList, appTypeList, appResultList, stageStatusList, orgList, speciesTypeList, ieTypeList, vanIdList, compareStateList, loginStateList, exceptionCodeList,tableNameList, fiTypeList };
export default Home;